import React from "react";
import PropTypes from "prop-types";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core/styles";
import TopAppBar from "../common_components/app_bar_options.component";
import BottomBar from "../common_components/bottom_bar_options.component";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import axiosConfig from "../axiosConfig";
import requireSub from "../common_components/requireAuthorized";
import logo from "../../assets/img/cw_logo.png";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    alignItems: "center",
    justifyContent: "center",
  },
  rootbkg: {
    flexGrow: 1,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "white",
  },
  paper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    boxShadow: 3,
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  text_title: {
    fontSize: "3rem",
    fontFamily: "Open Sans",
    fontWeight: "600",
    color: "#F6227F",
    "@media (min-width:200px)": {
      fontSize: "1rem",
    },
    "@media (min-width:600px)": {
      fontSize: "1.5rem",
    },
    "@media (min-width:960px)": {
      fontSize: "2rem",
    },
    textShadow: "1px 1px 2px #A7A7A7",
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
    textAlign: "center",
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    backgroundColor: "#FFF",
    width: 210,
    borderColor: "#F6277F",
    borderWidth: 40,
    height: 40,
  },
  notchedOutline: {
    borderWidth: "1px",
    borderColor: "#000 !important",
  },
  labelColor: {},
  signin_text: {
    fontFamily: "Open Sans",
    textAlign: "left",
    marginLeft: "15%",
    marginRight: "15%",
    marginTop: "2%",
  },
  join_text: {
    color: "#F6277F",
    fontWeight: "600",
    fontFamily: "Open Sans",
    textTransform: "none",
  },
  enter_text: {
    color: "#FFF",
    fontWeight: "600",
    fontFamily: "Open Sans",
    fontSize: 14,
    textTransform: "none",
  },
  fieldset: {
    borderColor: "#F6227F",
    borderWidth: 1,
    borderRadius: 7,
    width: "70%",
    marginLeft: "15%",
    marginTop: "3%",
  },
  legend_text: {
    color: "black",
    fontFamily: "Open Sans",
    fontSize: 20,
    fontWeight: "700",
  },
  icon: {
    fill: "#F6277F",
  },
  splash_text: {
    fontSize: "3rem",
    fontFamily: "Open Sans",
    fontWeight: "200",
    "@media (min-width:200px)": {
      fontSize: "1rem",
    },
    "@media (min-width:600px)": {
      fontSize: "1.5rem",
    },
    "@media (min-width:960px)": {
      fontSize: "2rem",
    },
  },
  input: {
    minHeight: 100,
  },
});

const btype_arr = [
  {
    value: "R",
    label: "Retail",
  },
  {
    value: "S",
    label: "Seller",
  },
  {
    value: "C",
    label: "Company",
  },
];

class CompanyInfo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fname: "",
      lname: "",
      pnumber: "",
      email: "",
      bname: "",
      btype: "",
      lnumber: "",
      ltype: "",
      country: "",
      addline_one: "",
      addline_two: "",
      city: "",
      province: "",
      postal: "",
      website: "",
      comments: "",
      dialog: false,
      redirect: false,
    };
    this.submitForm = this.submitForm.bind(this);
    this.handleCloseDelete = this.handleCloseDelete.bind(this);
    let brand_id = sessionStorage.getItem("brand_id");
    if (!brand_id) {
      // console.log("Im IN");
      this.props.history.push("/login");
    } else {
      // console.log("BRAND ID IS", brand_id);
      try {
        axiosConfig
          .get(`/brand/${brand_id}`)
          .then((product_response) => {
            // console.log("BRAND IS: ", product_response);
            this.loadData(product_response.data);
          })
          .catch((err) => {
            // console.log(err);
            // console.log(err.response);
            //alert('Unexpected Error')
          });
      } catch (err) {
        // console.log(err);
      }
    }
  }

  componentDidMount() {
    document.title = "Company Info | CanaWho";
  }

  handleCloseDelete() {
    this.setState({
      dialog: false,
      comments: "",
    });
  }

  submitForm() {
    const { comments } = this.state;
    if (comments.trim()) {
      try {
        axiosConfig
          .post(`/brand/requestChange`, {
            name: this.state.bname,
            details: this.state.comments,
          })
          .then((response) => {
            // console.log("Response IS: ", response);
            if (response.data.status) {
              this.setState({ dialog: true });
            }
          })
          .catch((err) => {
            // console.log(err)
            // console.log(err.response)
            //alert('Unexpected Error')
          });
      } catch (err) {
        // console.log(err);
      }
    } else {
      alert("Please fill in the field");
    }
  }

  loadData(product_response) {
    this.setState({ loading: true });
    // console.log(product_response);
    this.setState({
      fname: product_response.contact.first_name
        ? product_response.contact.first_name
        : "Not Available",
      lname: product_response.contact.last_name
        ? product_response.contact.last_name
        : "Not Available",
      pnumber: product_response.contact.phone_number
        ? product_response.contact.phone_number
        : "Not Available",
      email: product_response.contact.email
        ? product_response.contact.email
        : "Not Available",
      bname: product_response.name ? product_response.name : "Not Available",
      btype: product_response.type ? product_response.type : "Not Available",
      lnumber: product_response.license_number
        ? product_response.license_number
        : "Not Available",
      ltype: product_response.license_type
        ? product_response.license_type
        : "Not Available",
      country: product_response.country
        ? product_response.country
        : "Not Available",
      addline_one: product_response.address_line1
        ? product_response.address_line1
        : "Not Available",
      addline_two: product_response.address_line2
        ? product_response.address_line2
        : "Not Available",
      city: product_response.city ? product_response.city : "Not Available",
      province: product_response.province
        ? product_response.province
        : "Not Available",
      postal: product_response.postal_code
        ? product_response.postal_code
        : "Not Available",
      website: product_response.website
        ? product_response.website
        : "Not Available",
      loading: false,
    });
  }

  render() {
    const { classes } = this.props;
    const {
      fname,
      lname,
      pnumber,
      email,
      bname,
      lnumber,
      country,
      btype,
      ltype,
      dialog,
      addline_one,
      addline_two,
      city,
      province,
      postal,
      website,
      comments,
    } = this.state;

    return (
      <div className={classes.root}>
        <TopAppBar />
        <Grid container direction="column" alignItems="center" justify="center">
          <div className={classes.paper}>
            <Grid
              style={{ width: "100%" }}
              container
              alignItems="center"
              justify="center"
            >
              <h1 className={classes.text_title}>COMPANY INFORMATION</h1>
            </Grid>
            <form className={classes.form} noValidate>
              <fieldset className={classes.fieldset}>
                <legend className={classes.legend_text}>
                  Contact Information
                </legend>
                <Grid container direction="row" justify="space-evenly">
                  <Grid item xs={6}>
                    <TextField
                      style={{ width: "80%" }}
                      variant="outlined"
                      margin="normal"
                      disabled
                      id="first_name"
                      label="First Name"
                      //name="first_name"
                      type="text"
                      value={fname}
                      onChange={(text) => {
                        this.setState({ fname: text.target.value });
                      }}
                      autoComplete="section-name"
                      autoFocus
                      InputLabelProps={{ style: { color: "grey" } }}
                      InputProps={{
                        classes: { notchedOutline: classes.notchedOutline },
                      }}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      style={{ width: "80%" }}
                      variant="outlined"
                      margin="normal"
                      disabled
                      //name="last_name"
                      label="Last Name"
                      type="text"
                      id="password"
                      autoComplete="current-password"
                      value={lname}
                      onChange={(text) => {
                        this.setState({ lname: text.target.value });
                      }}
                      InputLabelProps={{ style: { color: "grey" } }}
                      InputProps={{
                        classes: { notchedOutline: classes.notchedOutline },
                      }}
                    />
                  </Grid>
                </Grid>
                <Grid container direction="row" justify="space-evenly">
                  <Grid item xs={6}>
                    <TextField
                      style={{ width: "80%" }}
                      variant="outlined"
                      margin="normal"
                      disabled
                      id="phone_number"
                      label="Phone Number"
                      //name="phone_number"
                      type="tel"
                      autoComplete="section-phone-number"
                      value={pnumber}
                      onChange={(text) => {
                        this.setState({ pnumber: text.target.value });
                      }}
                      InputLabelProps={{ style: { color: "grey" } }}
                      InputProps={{
                        classes: { notchedOutline: classes.notchedOutline },
                      }}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      style={{ width: "80%", marginBottom: 18 }}
                      variant="outlined"
                      margin="normal"
                      disabled
                      //name="email"
                      label="Email"
                      type="text"
                      id="email"
                      autoComplete="current-email"
                      value={email}
                      onChange={(text) => {
                        this.setState({ email: text.target.value });
                      }}
                      InputLabelProps={{ style: { color: "grey" } }}
                      InputProps={{
                        classes: { notchedOutline: classes.notchedOutline },
                      }}
                    />
                  </Grid>
                </Grid>
              </fieldset>
              <fieldset className={classes.fieldset}>
                <legend className={classes.legend_text}>
                  Business Information
                </legend>
                <Grid container direction="row" justify="space-evenly">
                  <Grid item xs={6}>
                    <TextField
                      style={{ width: "80%" }}
                      variant="outlined"
                      margin="normal"
                      disabled
                      id="usiness_name"
                      label="Business Name"
                      //name="business_name"
                      type="text"
                      autoComplete="section-name"
                      value={bname}
                      onChange={(text) => {
                        this.setState({ bname: text.target.value });
                      }}
                      InputLabelProps={{ style: { color: "grey" } }}
                      InputProps={{
                        classes: { notchedOutline: classes.notchedOutline },
                      }}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      style={{ width: "80%" }}
                      variant="outlined"
                      margin="normal"
                      disabled
                      //name="business_type"
                      label="Business Type"
                      type="text"
                      id="business_type"
                      value={btype}
                      InputLabelProps={{ style: { color: "grey" } }}
                      SelectProps={{
                        native: true,
                        classes: { icon: classes.icon },
                      }}
                      InputProps={{
                        classes: { notchedOutline: classes.notchedOutline },
                      }}
                    >
                      {btype_arr.map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </TextField>
                  </Grid>
                </Grid>
                <Grid container direction="row" justify="space-evenly">
                  <Grid item xs={6}>
                    <TextField
                      style={{ width: "80%" }}
                      variant="outlined"
                      margin="normal"
                      disabled
                      id="license_number"
                      label="License Number"
                      //name="license_number"
                      type="text"
                      autoComplete="section-number"
                      value={lnumber}
                      onChange={(text) => {
                        this.setState({ lnumber: text.target.value });
                      }}
                      InputLabelProps={{ style: { color: "grey" } }}
                      InputProps={{
                        classes: { notchedOutline: classes.notchedOutline },
                      }}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      style={{ width: "80%" }}
                      variant="outlined"
                      margin="normal"
                      disabled
                      //name="license_type"
                      label="License Type"
                      type="text"
                      id="license_type"
                      autoComplete="section-type"
                      value={ltype}
                      InputLabelProps={{ style: { color: "grey" } }}
                      SelectProps={{
                        native: true,
                        classes: { icon: classes.icon },
                      }}
                      InputProps={{
                        classes: { notchedOutline: classes.notchedOutline },
                      }}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      style={{ width: "80%" }}
                      variant="outlined"
                      margin="normal"
                      disabled
                      //name="country"
                      label="Country"
                      type="text"
                      id="country"
                      autoComplete="section-country"
                      value={country}
                      InputLabelProps={{ style: { color: "grey" } }}
                      SelectProps={{
                        native: true,
                        classes: { icon: classes.icon },
                      }}
                      InputProps={{
                        classes: { notchedOutline: classes.notchedOutline },
                      }}
                    />
                  </Grid>
                  <Grid item xs={6}></Grid>
                  <Grid item xs={12}>
                    <TextField
                      style={{ width: "90%" }}
                      variant="outlined"
                      margin="normal"
                      disabled
                      //name="address_one"
                      label="Adress Line 1"
                      type="text"
                      id="address_one"
                      autoComplete="section-address"
                      value={addline_one}
                      onChange={(text) => {
                        this.setState({ addline_one: text.target.value });
                      }}
                      InputLabelProps={{ style: { color: "grey" } }}
                      InputProps={{
                        classes: { notchedOutline: classes.notchedOutline },
                      }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      style={{ width: "90%" }}
                      variant="outlined"
                      margin="normal"
                      disabled
                      //name="address_two"
                      label="Adress Line 2"
                      type="text"
                      id="address_two"
                      autoComplete="section-address"
                      value={addline_two}
                      onChange={(text) => {
                        this.setState({ addline_two: text.target.value });
                      }}
                      InputLabelProps={{ style: { color: "grey" } }}
                      InputProps={{
                        classes: { notchedOutline: classes.notchedOutline },
                      }}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      style={{ width: "80%" }}
                      variant="outlined"
                      margin="normal"
                      disabled
                      id="city"
                      label="City"
                      //name="city"
                      type="text"
                      autoComplete="section-city"
                      value={city}
                      onChange={(text) => {
                        this.setState({ city: text.target.value });
                      }}
                      InputLabelProps={{ style: { color: "grey" } }}
                      InputProps={{
                        classes: { notchedOutline: classes.notchedOutline },
                      }}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      style={{ width: "80%" }}
                      variant="outlined"
                      margin="normal"
                      disabled
                      //name="province"
                      label="Province"
                      type="text"
                      id="province"
                      autoComplete="section-province"
                      value={province}
                      onChange={(text) => {
                        this.setState({ province: text.target.value });
                      }}
                      InputLabelProps={{ style: { color: "grey" } }}
                      InputProps={{
                        classes: { notchedOutline: classes.notchedOutline },
                      }}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      style={{ width: "80%" }}
                      variant="outlined"
                      margin="normal"
                      disabled
                      id="postal_code"
                      label="Postal Code"
                      //name="postal_code"
                      type="text"
                      autoComplete="section-postal-code"
                      value={postal}
                      onChange={(text) => {
                        this.setState({ postal: text.target.value });
                      }}
                      InputLabelProps={{ style: { color: "grey" } }}
                      InputProps={{
                        classes: { notchedOutline: classes.notchedOutline },
                      }}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      style={{ width: "80%" }}
                      variant="outlined"
                      margin="normal"
                      disabled
                      //name="website"
                      label="Website"
                      type="text"
                      id="website"
                      autoComplete="section-website"
                      value={website}
                      onChange={(text) => {
                        this.setState({ website: text.target.value });
                      }}
                      InputLabelProps={{ style: { color: "grey" } }}
                      InputProps={{
                        classes: { notchedOutline: classes.notchedOutline },
                      }}
                    />
                  </Grid>
                </Grid>
              </fieldset>
              <Grid
                container
                direction="column"
                alignItems="center"
                justify="center"
                style={{ marginBottom: "1.5%" }}
              >
                <Typography variant="h6" className={classes.signin_text}>
                  In order to update any of the information above (ie. contact
                  information and brand information), you must outline the
                  changes that you would like to make in the space provided
                  below. Our team will review your request and will be in
                  contact with you shortly. Express Yourself!
                  <br />
                  <br />
                  Please provide details about your requested change:
                </Typography>
              </Grid>
              <Grid
                container
                direction="row"
                justify="center"
                alignItems="center"
              >
                <Grid item xs={12} style={{ marginBottom: 18 }}>
                  <TextField
                    style={{ width: "72%", marginLeft: "1.5%" }}
                    variant="outlined"
                    margin="normal"
                    multiline
                    required
                    //name="additional_comments"
                    label="Details"
                    type="text"
                    id="details"
                    autoComplete="section-text"
                    value={comments}
                    onChange={(text) => {
                      this.setState({ comments: text.target.value });
                    }}
                    InputLabelProps={{ style: { color: "grey" } }}
                    InputProps={{
                      classes: { notchedOutline: classes.notchedOutline },
                      className: classes.input,
                    }}
                  />
                </Grid>
              </Grid>
              <Button
                // type="submit"
                fullWidth
                variant="contained"
                style={{
                  backgroundColor: "#F6277F",
                  boxShadow: "2",
                  width: 210,
                }}
                className={classes.submit}
                onClick={() => this.submitForm()}
              >
                <Typography variant="h6" className={classes.enter_text}>
                  Request Change
                </Typography>
              </Button>
            </form>
            <Grid>
              <img
                alt=""
                style={{ padding: 10, marginTop: 16, height: 80 }}
                src={logo}
              />
            </Grid>
          </div>
        </Grid>
        <Dialog
          open={dialog}
          onClose={this.handleCloseDelete}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{"Confirm"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Your request has been sent.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleCloseDelete} color="primary">
              Okay
            </Button>
          </DialogActions>
        </Dialog>
        <BottomBar />
      </div>
    );
  }
}

CompanyInfo.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default requireSub(withStyles(styles)(CompanyInfo));
